import { render, staticRenderFns } from "./EventDrops.vue?vue&type=template&id=64f5e2fc&scoped=true&"
import script from "./EventDrops.vue?vue&type=script&lang=js&"
export * from "./EventDrops.vue?vue&type=script&lang=js&"
import style0 from "./EventDrops.vue?vue&type=style&index=0&id=64f5e2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5e2fc",
  null
  
)

export default component.exports